import React, { useState, useContext } from 'react';
import { Button, Modal } from "react-bootstrap";
import request from '../../../services/request';
import { ThemeContext } from '../../../../context/ThemeContext';

export default function UploadModal(props) {
    const { changeSpinnerStatus } = useContext(ThemeContext);

    const [showModal, setShowModal] = useState(false);
    const formData = new FormData();
    formData.append("id", props.selectedRow.id)
    const onFileChange = (e) => {
        formData.append("file", e.target.files[0]);
    }

    const uploadFile = () => {
        request({
            method: "post",
            url: props.requestTo,
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        }, changeSpinnerStatus).then((response) => {
            if (response.responseStatus === "SUCCESS") {
                setShowModal(false)
            }
        })
    }

    let modal = <Modal className="modal fade" show={showModal}>
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title">Dosya Yükle</h5>
                <Button
                    variant=""
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    onClick={() => setShowModal(false)}
                >
                    <span>×</span>
                </Button>
            </div>
            <div className="modal-body">
                <input
                    type="file"
                    onChange={e => onFileChange(e)}
                />
            </div>
            <div className="modal-footer">
                <Button
                    type="button"
                    className="submit btn btn-primary float-right btn-sm"
                    onClick={() => uploadFile()}
                >
                    Tamamla
                </Button>
            </div>
        </div>
    </Modal>;
    let btn = React.Children.only(props.children);
    let content = React.cloneElement(
        btn,
        {
            onClick: () => {
                setShowModal(true)
            },
        },
        btn.props.children
    );
    return (
        <>
            {modal}
            {content}
        </>
    )
}
